export default "__VITE_ASSET__yeIVZpdc__"